import Vue from 'vue'
import ServiceDialog from '@/components/ServiceDialog.vue'
import ProductDialog from '@/components/ProductDialog.vue'
import store from '@/store' // 导入 store
import i18n from '@/i18n' // 导入 i18n

const ServiceConstructor = Vue.extend(ServiceDialog)
const ProductConstructor = Vue.extend(ProductDialog)

let instance
let instance2

const showServiceDialog = function(item) {
  if (!instance) {
    instance = new ServiceConstructor({
      el: document.createElement('div'),
      store, // 注入 store
      i18n, // 注入 i18n
      propsData: {
        item // 传入类型参数
      }
    })
    document.body.appendChild(instance.$el)
  }else {
    instance.item = item
  }
  instance.show()
}

const showProductDialog = function(item) {
  if (!instance2) { // 修复：使用 instance2 而不是 instance
    instance2 = new ProductConstructor({
      el: document.createElement('div'),
      store, // 注入 store
      i18n, // 注入 i18n
      propsData: {
        item // 传入类型参数
      }
    })
    document.body.appendChild(instance2.$el)
  }else {
    instance2.item = item // 修复：使用 instance2 而不是 instance
  }
  instance2.show()
}

export default {
  install(Vue) {
    Vue.prototype.$service = (item) => showServiceDialog(item)
    Vue.prototype.$product = (item) => showProductDialog(item)
  }
} 